<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-1/3 max-h-full p-8 rounded-lg bg-primary-purple-light-2 overflow-auto">
        <div class="relative rounded-lg dark:bg-gray-700">
            <header class="flex flex-row justify-between gap-4">
                <div class="text-base font-bold text-primary-purple">{{ literalService.get(text, true) }}</div>

                <div class="w-6 h-6 min-w-6">
                    <button (click)="closeModal()" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <img [src]="images.close" class="h-6 w-6" />
                    </button>
                </div>
            </header>
            <div class="py-10 flex flex-col gap-4">
                @for (value of values; track $index) {
                    <app-checkbox [id]="`app-${value.id}`" [value]="value" [checked]="isOptionChecked(value.id)" (change)="onClickCheckbox(value.id)" />
                }
            </div>
            <footer class="flex flex-row justify-between gap-4">
                <button type="button" class="secondary gap-4 py-1 px-6 border-2 font-semibold h-11 w-full uppercase cursor-pointer" (click)="closeModal()">{{ literalService.get('cancel', true) }}</button>
                <button type="button" class="primary gap-4 py-1 px-6 border-2 font-semibold h-11 w-full uppercase cursor-pointer" [disabled]="selectedValues.length === 0" (click)="action.emit(selectedValues)">{{ literalService.get('select', true) }}</button>
            </footer>
        </div>
    </div>
</div>